export class ChatBotMessage {
  senderId: string;
  displayName: string;
  photoURL: string;
  message: string;
  createdAt: number;
  isRead: boolean;

  constructor(
    senderId?: string,
    displayName?: string,
    photoURL?: string,
    message?: string,
    createdAt?: number,
    isRead?: boolean
  ) {
    this.senderId = senderId || null;
    this.displayName = displayName || null;
    this.photoURL = photoURL || null;
    this.message = message || null;
    this.createdAt = createdAt || Date.now();
    this.isRead = isRead || false;
  }
}
